"use client"

import DeleteTable from "@/components/deleteDomain/DeleteTable";
import { getNormalDomains, getPermaDeleteDomains } from "@/services/domains.service";
import { useEffect, useState } from "react";

export interface DeleteView {
    ID: string,
    Name: string,
    DBRel: string,
    Website: string,
    Folder: string,
    Package: string,
    CompanyID: number
}

export default function DeletePage() {
    const [domains, setDomains] = useState<DeleteView[]>([]);
    const [permaDeleteDomains, setPermaDeleteDomains] = useState<DeleteView[]>([]);

    const loadAllDomains = async () => {
        const domains = await getNormalDomains();
        if(domains.length > 0){
            const arr = domains.map(d => {
                return {ID: d.ID, Name: d.Name, DBRel: d.DBRel, Website: d.Website, Folder: d.Folder, Package: d.Package, CompanyID: Number(d.CompanyID)}
            });
            setDomains(arr);
        } else {
            setDomains([]);
        }

        const permaDeleteDomains = await getPermaDeleteDomains();
        if(permaDeleteDomains.length > 0){
            const arr = permaDeleteDomains.map(d => {
                return {ID: d.ID, Name: d.Name, DBRel: d.DBRel, Website: d.Website, Folder: d.Folder, Package: d.Package, CompanyID: Number(d.CompanyID)}
            });
            setPermaDeleteDomains(arr);
        } else {
            setPermaDeleteDomains([]);
        }
    }

    useEffect(() => {
        loadAllDomains();
    }, [])
    return (
        <DeleteTable domains={domains} permaDeleteDomains={permaDeleteDomains} />
    )
}